import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  Container,
  Divider,
  Chip,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../actions/auth";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const AuthorProfile = () => {
  const state = useSelector((state) => state);
  const location = useLocation();

  const { authID } = useParams();
  const [author, setAuthor] = useState({});
  const [posts, setPosts] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAuthorData = async () => {
    setLoading(true);

    axios
      .post(API_URL + "get_author_info", {
        auth_id: location.pathname.split("/")[2].replaceAll("/", ""),
      })
      .then((res) => {
        setAuthor(res.data);
        axios
          .post(API_URL + "author_blogs_and_case_studies", {
            auth_id: location.pathname.split("/")[2].replaceAll("/", ""),
          })
          .then((res) => {
            setPosts(res.data["blogs"]);
            setLoading(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchAuthorData();
  }, [authID]);

  return (
    <div className="main anigrad">
      <Sidebar />
      <div style={{ marginTop: state.auth.isMobile ? "20vh" : "6vh" }} />
      <div
        style={{
          padding: state.auth.isMobile ? "15px" : "100px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar
          alt={author.name}
          src={API_URL + author.image}
          sx={{
            width: 150,
            height: 150,
            mb: 3,
          }}
        />
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          style={{ color: "white" }}
        >
          {author.name}
        </Typography>
        <Chip label={author.designation} color="primary" sx={{ mb: 2 }} />
        <Typography
          variant="h6"
          component="h2"
          sx={{ maxWidth: "800px", color: "white" }}
        >
          {author.description}
        </Typography>
      </div>
      <div
        style={{
          padding: state.auth.isMobile ? "15px" : "100px",
          marginTop: state.auth.isMobile ? "0px" : "-100px",
        }}
      >
        {posts.length > 0 && (
          <>
            <Typography
              variant="h4"
              component="h2"
              sx={{ mb: 3, mt: 6, color: "white" }}
            >
              Blog Posts
            </Typography>
            <Divider sx={{ mb: 4 }} />
            <Grid container spacing={4}>
              {posts.map((post) => (
                <Grid item xs={12} sm={6} md={4} key={post.slug}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <CardActionArea href={`/blog/${post.slug}`}>
                      <CardMedia
                        component="img"
                        height="200"
                        image={API_URL + "media/" + post.post_id + ".jpg"}
                        alt={post.title}
                      />
                      <CardContent sx={{ flexGrow: 1 }}>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            fontSize: "25px",
                          }}
                        >
                          {post.title}
                        </div>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </>
        )}

        {/* Message if no content */}
        {posts.length === 0 && (
          <Typography variant="h6" sx={{ textAlign: "center", my: 6 }}>
            No blog posts or case studies found for this author.
          </Typography>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AuthorProfile;
